import { defineMessages } from 'react-intl';

export default defineMessages({
    prQuoteValidityDays: {
        id: 'quoteandbind.views.ppr.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR {quoteValidityDays} DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
    prBrokerageCommission: {
        id: 'quoteandbind.views.ppr.quote.Brokerage Commission',
        defaultMessage: 'Brokerage Commission',
    },
    prMimimumRetainedPremium: {
        id: 'quoteandbind.views.ppr.quote.Minimum Retained Premium',
        defaultMessage: 'Minimum Retained Premium',
    },
    note1: {
        id: 'quoteandbind.views.ppr.quote.note1',
        defaultMessage: 'NOTE: The terms we have offered are not necessarily identical to those requested in your apprication for insurance/ submission form, nor is Premier Canada Assurance obligated to offer such terms.   Please review the terms and conditions of this quote carefully.  Relevant policy forms may be obtained from the undersigned underwriter or refer to our website to locate the appricable forms (please note revision dates for the appropriate form).'
    }, 
    note2: {
        id: 'quoteandbind.views.ppr.quote.note2',
        defaultMessage: 'INSURANCE LICENSE NOTICE: Premier Canada Assurance has provided this quotation on the basis that you are duly licensed to sell insurance in the jurisdiction pertaining to this insurance risk.  By virtue of the fact that you have requested this quotation, you are representing to Premier Canada Assurance that you are a duly licensed insurance broker in the relevant jurisdiction.  Premier Canada Assurance may request a copy of such license at any time.'
    }, 
    policyfees: {
        id: 'quoteandbind.views.ppr.quote.Policy Fee',
        defaultMessage: 'Policy Fee'
    }, 
    infees: {
        id: 'quoteandbind.views.ppr.quote.Inspection Fee',
        defaultMessage: 'Inspection Fee'
    }, 
    exfees: {
        id: 'quoteandbind.views.ppr.quote.Extension Fee',
        defaultMessage: 'Extension Fee'
    },
     stoFacNamValue: {
        id: 'quoteandbind.PPRLinedirectives.templates.Quote.Storage Facility Name',
        defaultMessage: 'Storage Facility Name : '
    },
    stoFacLocValue: {
        id: 'quoteandbind.PPLProLinedirectives.templates.Quote.Storage Facility Location',
        defaultMessage: 'Storage Facility Location : '
    }
});
